import http from './http-common';
import storage from '../factory/StorageFactory';

const postState = (webDet,packageID) => {
    var browserDetails = navigator.userAgent;
    let params = {
        data: {
            broswerDetails: webDet,
            hostName: window.location.hostname,
            userAgent: browserDetails,
        }
    };

    let bodyParams = {
        packageId: packageID,  
        dataFields: '<Fields><broswerDetails><name>'+params.data.broswerDetails.name+'</name><version>'+params.data.broswerDetails.version+'</version><fullVersion>'+params.data.broswerDetails.fullVersion+'</fullVersion><os>'+params.data.broswerDetails.os+'</os></broswerDetails><hostName>'+params.data.hostName+'</hostName><userAgent>'+params.data.userAgent+'</userAgent></Fields>'
    }

    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }
    return http.post(`/api/v1/SMEDL/postState`, bodyParams, headerParams);
}

const postResumeState = (bodyParams) => {

    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }
    return http.post(`/api/v1/SMEDL/postState`, bodyParams, headerParams);
}


const getStateValidate = (stateId, param) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    let url = '/api/v1/State/validate/' + stateId;
    if (param) {
        url = url + '/' + param
    }
    return http.get(url, headerParams);
}

const getStateCheck = (stateId) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    let url = '/api/v1/State/check/' + stateId;
    return http.get(url, headerParams);
}


export default {
    postState,
    postResumeState,
    getStateValidate,
    getStateCheck
}

